import { render, staticRenderFns } from "./AddTask.vue?vue&type=template&id=4f75a5a2&"
import script from "./AddTask.vue?vue&type=script&lang=js&"
export * from "./AddTask.vue?vue&type=script&lang=js&"
import style0 from "./AddTask.vue?vue&type=style&index=0&id=4f75a5a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports